import { useEffect, useRef } from 'react';

const useEventListener = (eventName, handler) => {
  const eventHandler = useRef();

  if (!eventHandler.current) {
    eventHandler.current = handler;
  }

  useEffect(() => {
    window.addEventListener(eventName, eventHandler.current);

    return () => {
      window.removeEventListener(eventName, eventHandler.current);
    };
  }, [eventName]);
};

export default useEventListener;
